import React from 'react'
import { useNavigate } from 'react-router-dom'

function Thankyou() {
    const navigate = useNavigate();
    const goback = () => {
        navigate('/')
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    return (
        <div>
            <div className="flex items-center justify-center h-screen bg-gray-100">
                <div className="bg-white p-8 rounded-2xl shadow-lg text-center max-w-md">
                    <div className="flex items-center justify-center w-16 h-16 bg-[#00725D] text-white rounded-full mx-auto mb-4">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            className="w-10 h-10"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M5 13l4 4L19 7"
                            />
                        </svg>
                    </div>
                    <h2 className="text-2xl font-bold text-[#00725D]">Thank You!</h2>
                    <p className="text-gray-600 mt-2">
                        Your form has been submitted successfully. We will get back to you soon.
                    </p>
                    <button onClick={() => { goback() }} className="mt-4 px-6 py-2 bg-[#00725D] text-white rounded-lg hover:bg-[#005f4a] transition">
                        Go Back
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Thankyou